import { render, staticRenderFns } from "./GroupItems.vue?vue&type=template&id=b506a82e&scoped=true&"
import script from "./GroupItems.vue?vue&type=script&lang=js&"
export * from "./GroupItems.vue?vue&type=script&lang=js&"
import style0 from "./GroupItems.vue?vue&type=style&index=0&id=b506a82e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b506a82e",
  null
  
)

export default component.exports